<template>
  <draggable
    tag="ul"
    :list="list"
    :group="{ name: 'g1' }"
    :emptyInsertThreshhold="500"
    class="dragArea ml-4"
  >
    <li v-for="item in list" :key="item.id">
      <WsSortItem
        :itemName="item[titleKey]"
        :style="{'z-index': '9999'}"
      > {{item[titleKey]}} </WsSortItem>
      <LvStateSort
        v-if="item.children"
        :list="item.children"
        :titleKey="titleKey"
        :class="{'py-2': item.children.length > 0, 'py-1': item.children.length === 0}"
      />
    </li>
  </draggable>
</template>
<script>
import draggable from 'vuedraggable';

export default {
  components: {
    draggable
  },
  props: {
    list: {
      type: Array,
    },
    titleKey: {
      type: String,
      default: 'name',
    }
  },
};
</script>
<style scoped>
  .dragArea {
    min-height: 10px;
  }
</style>